/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-08-30 14:16:37
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { Layout } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { mixpanelV3Helper } from 'src/helpers/mixpanel-v3';

type Props = {
  onDismiss: Function,
  emailSupport: string
};

type ComposedProps = Props & WithI18nProps;

class RecommendedAppsBanners extends Component<ComposedProps> {
  onClickAppBanner = (link: string) => {
    mixpanelV3Helper.trackEventData('Click Integration Banner', {
      url: link
    });
  };

  render() {
    const { banners } = this.props;
    return (
      <React.Fragment>
        {_.map(banners, (banner, index) => {
          const { image, name, url } = banner;
          return (
            <Layout.Section oneHalf key={index}>
              <a
                className="Polaris-Link"
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  this.onClickAppBanner(url);
                }}>
                <img style={{ width: '100%', marginTop: '2.4rem' }} src={image.source} alt={name} />
              </a>
            </Layout.Section>
          );
        })}
      </React.Fragment>
    );
  }
}

export default withI18n()(RecommendedAppsBanners);
